"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleBar = void 0;
var pdfTheme_1 = require("../pdfTheme");
var fontSize = pdfTheme_1.pdfTheme.font.size.default;
var TitleBar = /** @class */ (function () {
    function TitleBar(collectionTitle, jobName, currentPoleIndex, totalPoles, pageBreak) {
        this.collectionTitle = collectionTitle;
        this.jobName = jobName;
        this.currentPoleIndex = currentPoleIndex;
        this.totalPoles = totalPoles;
        // if the title wraps to a second line, this will break
        this.height = fontSize * pdfTheme_1.MAGIC_SCALING_NUMBER + pdfTheme_1.pdfTheme.spacing.default * 2;
        this.pageBreak = pageBreak === 'none' ? undefined : pageBreak;
    }
    TitleBar.prototype.exportContent = function () {
        return {
            pageBreak: this.pageBreak,
            fillColor: pdfTheme_1.pdfTheme.background.default,
            layout: {
                paddingTop: function () { return pdfTheme_1.pdfTheme.spacing.default; },
                paddingBottom: function () { return pdfTheme_1.pdfTheme.spacing.default; },
                paddingLeft: function () { return pdfTheme_1.pdfTheme.spacing.default; },
                paddingRight: function () { return pdfTheme_1.pdfTheme.spacing.default; },
                defaultBorder: false,
                hLineWidth: function () { return 0; },
                vLineWidth: function () { return 0; }
            },
            margin: [0, 0],
            // we use tables because it's the easiest way to get backgrounds that span the entire width
            table: {
                widths: ['auto', '*'],
                body: [
                    [{ text: "Job: ".concat(this.jobName), style: ['text', 'left'], margin: 0 },
                        {
                            text: "".concat(this.collectionTitle, " (").concat(this.currentPoleIndex, " of ").concat(this.totalPoles, ")"),
                            style: ['text', 'right'],
                            margin: 0
                        }]
                ]
            }
        };
    };
    TitleBar.prototype.exportStyles = function () {
        return {
            text: {
                fontSize: fontSize,
                bold: true,
                color: pdfTheme_1.pdfTheme.font.color.dark
            },
            left: {
                alignment: 'left'
            },
            center: {
                alignment: 'center'
            },
            right: {
                alignment: 'right'
            }
        };
    };
    return TitleBar;
}());
exports.TitleBar = TitleBar;
//# sourceMappingURL=TitleBar.js.map